import Colors from "modules/Colors";
import { OrganizationRole } from "modules/Const";
import InputSymphony, { SelectOptionItem } from 'elements/InputSymphony';
import { CSSProperties } from 'react';
import { styx } from 'modules/Utils';

// Create select options for the roles
const roleOptions: SelectOptionItem[] = [
  {
    value: OrganizationRole.ADMINISTRATOR,
    title: 'Team Admin',
    description: 'Team Admins have full access to add and edit profiles, invite new teammates, create campaigns and websites, and update Billing settings.'
  },
  {
    value: OrganizationRole.MEMBER,
    title: 'Member',
    description: 'This teammate will have only have access to selected profiles, with customizable Admin or View-only permissions per profile.'
  }
];

interface MemberPermissionsSelectProps {
  className?: string;
  /** Currently selected role or empty string */
  value: OrganizationRole | '';
  /** Callback when role selection changes */
  onChange: (role: OrganizationRole) => void;
  required?: boolean;
  disabled?: boolean;
}

const MemberPermissionsSelect = ({
  className,
  value,
  onChange,
  required = false,
  disabled = false
}: MemberPermissionsSelectProps) => {
  const handleOptionSelect = (option: SelectOptionItem) => {
    onChange(option.value as OrganizationRole);
  };

  return (
    <div className="memberPermissionsSelect_SYMPHONY" style={styx(sty.container)}>
      <InputSymphony
        className={className || ''}
        value={value}
        placeholder="Select permissions"
        isSelectDropdown={true}
        options={roleOptions}
        onOptionSelect={handleOptionSelect}
        disabled={disabled}
        styleInput={styx(sty.inputStyle)}
      />
    </div>
  );
};

const sty: Record<string, CSSProperties> = {
  container: {
    width: '100%'
  },
  inputStyle: {
    height: 45,
    fontFamily: 'DIN',
    fontSize: 16,
  }
};

export default MemberPermissionsSelect;